<template>
  <output-dialog
    :pages="pages"
    filename="INV・PL.pdf"
    orientation="portrait"
    ref="printDlg"
    title="Invoice And Packing List"
  >
    <template slot-scope="{page}">
      <document-page1 :invoice="page" v-if="page._type===0" />
      <document-page2 :invoice="page" v-if="page._type===1" />
      <document-page3 :invoice="page" v-if="page._type===2" />
      <document-page4 :invoice="page" v-if="page._type===3" />
    </template>
  </output-dialog>
</template>
<script>
// TODO: 発注依頼者,有償：POの支払条件＋サイト 無償：「No　Commercial Value」未完成

import DocumentPage1 from './DocumentPage1'
import DocumentPage2 from './DocumentPage2'
import DocumentPage3 from './DocumentPage3'
import DocumentPage4 from './DocumentPage4'
export default {
  components: { DocumentPage1, DocumentPage2, DocumentPage3, DocumentPage4 },
  data() {
    return {
      pages: []
    }
  },
  computed: {},
  methods: {
    totalCartonQty(invoice) {
      let cartons = invoice.packages
        .map(i => [i.cartonStartNo, i.cartonEndNo])
        .sort((a, b) => a[0] - b[0])
        .reduce((t, i) => {
          if (t.length === 0) {
            t.push(i)
          } else if (t[t.length - 1][1] >= i[0]) {
            t[t.length - 1][1] = i[1]
          } else {
            t = [...t, i]
          }
          return t
        }, [])
      console.log('cartons', cartons)
      return cartons.reduce((t, c) => t + c[1] - c[0] + 1, 0)
    },
    totalAmount(invoice) {
      return invoice.items.reduce((t, i) => t + i.subTotal, 0)
    },
    totalQty(invoice) {
      return invoice.items.reduce((t, i) => t + i.qty, 0)
    },
    cartonQty(pkg) {
      return pkg.cartonEndNo - pkg.cartonStartNo + 1
    },
    netWeight(pkg) {
      return this.cartonQty(pkg) * pkg.netWeight
    },
    grossWeight(pkg) {
      return this.cartonQty(pkg) * pkg.grossWeight
    },
    volume(pkg) {
      return this.cartonQty(pkg) * pkg.volume
    },
    totalNetWeight(invoice) {
      return invoice.packages.reduce((t, i) => t + this.netWeight(i), 0)
    },
    totalGrossWeight(invoice) {
      return invoice.packages.reduce((t, i) => t + this.grossWeight(i), 0)
    },
    totalVolume(invoice) {
      return invoice.packages.reduce((t, i) => t + this.volume(i), 0)
    },
    splitItems(invoice, total) {
      let items = invoice.items
      let pages = []
      let page = {
        ...invoice,
        items: [],
        pageIndex: ++total.value,
        total: total,
        _type: 1
      }
      pages.push(page)
      for (let i = 0; i < 10; i++) {
        let item = items.shift()
        if (!item) break
        page.items.push(item)
      }
      while (items.length > 0) {
        page = {
          ...invoice,
          items: [],
          pageIndex: ++total.value,
          total: total,
          _type: 1
        }
        pages.push(page)
        for (let i = 0; i < 10; i++) {
          let item = items.shift()
          if (!item) break
          page.items.push(item)
        }
      }
      return pages
    },
    splitPackages(invoice) {
      let packages = invoice.packages
      let pages = []
      let total = { value: 0 }
      let page = {
        ...invoice,
        packages: [],
        pageIndex: ++total.value,
        total: total,
        _type: 2
      }
      pages.push(page)
      for (let i = 0; i < 7; i++) {
        let pkg = packages.shift()
        if (!pkg) break
        page.packages.push(pkg)
      }
      while (packages.length > 0) {
        page = {
          ...invoice,
          packages: [],
          pageIndex: ++total.value,
          total: total,
          _type: 3
        }
        pages.push(page)
        for (let i = 0; i < 9; i++) {
          let pkg = packages.shift()
          if (!pkg) break
          page.packages.push(pkg)
        }
      }
      return pages
    },
    popup(pages) {
      this.pages = []
      this.$refs.printDlg.show = true
      this.pages = pages
        .map(p => {
          return {
            ...p,
            totalAmount: this.totalAmount(p),
            totalQty: this.totalQty(p),
            totalNetWeight: this.totalNetWeight(p),
            totalGrossWeight: this.totalGrossWeight(p),
            totalVolume: this.totalVolume(p),
            totalCartonQty: this.totalCartonQty(p)
          }
        })
        .map(p => {
          let total = { value: 1 }
          return [
            { ...p, total: total, _type: 0 },
            ...this.splitItems(p, total),
            ...this.splitPackages(p)
          ]
        })
        .reduce((a, p) => a.concat(p), [])
    }
  }
}
</script>


